import {
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import AlarmOffIcon from '@material-ui/icons/AlarmOff';
import WatchLaterSharpIcon from '@material-ui/icons/WatchLaterSharp';
import LoopIcon from '@material-ui/icons/Loop';
import React from 'react';
import { StatusIcon } from 'components/TableItems';
import i18n from 'i18n';
import { styleStatus } from './styles';

const useStyles = makeStyles(styleStatus);

interface Props {
  value: string;
  hiddenText?: boolean;
}

const StatusSchedule = ({ value, hiddenText }: Props) => {
  const classes = useStyles();

  const getCustom = () => {
    const status = value;

    let custom = {
      icon: <></>,
      textOpacity: false,
      label: '',
    };

    if (['ok'].includes(status)) {
      custom = {
        icon: <StatusIcon status="success" />,
        textOpacity: true,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.COMPLETED_KEY'),
      };
    } else if (['pending'].includes(status)) {
      custom = {
        icon: <WatchLaterSharpIcon className={classes.watchLaterIcon} />,
        textOpacity: false,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.PENDING_KEY'),
      };
    } else if (['error'].includes(status)) {
      custom = {
        icon: <StatusIcon status="blocked" />,
        textOpacity: false,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.ERROR_KEY'),
      };
    } else if (['canceled'].includes(status)) {
      custom = {
        icon: <StatusIcon status="inactive" />,
        textOpacity: false,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.CANCELLED_KEY'),
      };
    } else if (['executing'].includes(status)) {
      custom = {
        icon: <CircularProgress size={12} color="secondary" />,
        textOpacity: true,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.EXECUTING_KEY'),
      };
    } else if (['retry'].includes(status)) {
      custom = {
        icon: <LoopIcon className={classes.loopIcon} />,
        textOpacity: false,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.RETRYING_KEY'),
      };
    } else if (['expired'].includes(status)) {
      custom = {
        icon: <AlarmOffIcon className={classes.alarmIcon} />,
        textOpacity: false,
        label: i18n.t('ENVIRONMENTS_PAGE.STATUS.EXPIRED_KEY'),
      };
    }

    return custom;
  };

  return (
    <Grid container wrap="nowrap" alignItems="center" justify="center">
      <span className={clsx(classes.icon)}>{getCustom().icon}</span>
      {!hiddenText && (
        <Typography variant="body2" className={classes.textOpacity}>
          {getCustom().label}
        </Typography>
      )}
    </Grid>
  );
};

export default StatusSchedule;
